import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { AppProvider } from '../contexts/AppContext';
import { ErrorBoundary } from '../components/ErrorBoundary';
import { WebApp } from './web';

// 🔴 2026-07-17 v3.6.60: 生产环境去掉 StrictMode，消除双 mount 触发的 TDZ 时序问题
// dev 保留 StrictMode（有助于发现副作用 bug），prod 去掉（稳定优先）
const isProd = import.meta.env.PROD;
const App = (
  <ErrorBoundary>
    <AppProvider>
      <WebApp />
    </AppProvider>
  </ErrorBoundary>
);
createRoot(document.getElementById('root')!).render(
  isProd ? App : <StrictMode>{App}</StrictMode>,
);
